import { apiGet } from './api';
import type {
  DashboardOverviewResponse,
  DashboardSummary,
  DashboardStatistics,
  RecentActivityItem,
  StatisticsPeriod,
} from '../types/dashboard.types';

export const dashboardService = {
  /**
   * Fetch aggregated dashboard overview.
   */
  async getDashboardOverview(): Promise<DashboardOverviewResponse> {
    return apiGet<DashboardOverviewResponse>('/dashboard/overview');
  },

  /**
   * Fetch summary statistics counts.
   */
  async getDashboardSummary(): Promise<DashboardSummary> {
    return apiGet<DashboardSummary>('/dashboard/summary');
  },

  /**
   * Fetch detailed time-series statistics and breakdowns for a given period.
   */
  async getDashboardStatistics(
    period: StatisticsPeriod = '7d',
  ): Promise<DashboardStatistics> {
    return apiGet<DashboardStatistics>('/dashboard/statistics', { period });
  },

  /**
   * Fetch recent learning and review activities.
   */
  async getRecentActivity(limit = 10): Promise<RecentActivityItem[]> {
    return apiGet<RecentActivityItem[]>('/dashboard/activity', { limit });
  },
};
